export default function Paragraph({ children }) {

	return (
		<p className="text-[#8a8f98] text-sm sm:text-base pb-8">
			{children}
		</p>
	)
}
